module.exports = __webpack_public_path__ + "static/media/inspect-video.en.04ed0be3.vtt";